import gql from 'graphql-tag';
import { useQuery, useResult, useMutation } from '@vue/apollo-composable';
import { useProfileInfo } from '@models/profile/useCurrentProfile';
import baseConfig from '@/config/base.config';

const { profileInfo } = useProfileInfo();

// graphql - 热图设置
const SET_HEATMAP_MUTATION = gql`
    mutation setHeatMapWithToken($input: SetHeatMapInput!) {
        setHeatMapWithToken(input: $input)
    }
`;

// graphql - 新热图设置
const SET_MULTI_HEATMAP_WITH_TOKEN = gql`
    mutation setMultiHeatMapWithToken($token: String!, $configList: [SetHeatMapInput!]!) {
        setMultiHeatMapWithToken(token: $token, configList: $configList)
    }
`;

// export const areaConfig: any = {
//     'localhost:3002': 'l',
//     'dev.ptmind.com': '0',
//     'dev.ptmind.cn': '1',
//     'staging.ptmind.com': '2',
//     'staging.ptmind.cn': '3',
//     'www.ptengine.jp': '4',
//     'www.ptengine.com': '5'
// };

export function addProtocol(url: string): string {
    const reg = /^(http|https:\/\/)/;
    return url !== '' && !reg.test(url) ? `http://${url}` : url;
}

/**
 * 热图设置
 */
export function setHeatMap(option: any, token: string) {
    const { mutate: setHeatMapWithToken } = useMutation(SET_HEATMAP_MUTATION);
    option.dataParameter.timeZone = profileInfo.value?.timeZone;
    option.pageInfo.authType = baseConfig.HEATMAP_DEFAULT_SHARE_AUTH_TYPE;
    option.pageInfo.profileName = profileInfo.value?.name;
    const SetHeatMapInput = {
        token,
        config: option
    };
    return setHeatMapWithToken({ input: SetHeatMapInput })
        .then((result: any) => {
            return result.data.setHeatMapWithToken;
        })
        .catch((err: any) => {
            return false;
        });
}

/**
 * 新热图设置
 */
export function setMultiHeatMapData(configList: any, token: string) {
    const { mutate: setMultiHeatMapWithToken } = useMutation(SET_MULTI_HEATMAP_WITH_TOKEN);
    return setMultiHeatMapWithToken({ configList: configList, token: token })
        .then((result: any) => {
            return result.data.setMultiHeatMapWithToken;
        })
        .catch((err: any) => {
            return false;
        });
}
